import React, { memo, Fragment } from 'react';
import { appDispatch } from 'store/store';

import QuestionViewer from '../QuestionViewer';
import GridFieldsEditor, { GridFieldsViewer } from './GridFields';
import MultiChoiceEditor, { MultiChoiceViewer } from '../MultiChoice';
import Icon from 'components/Icon';
import { IGridQuestionView, QuestionState } from 'store/survey/surveyTypes';
import i18n from '../../../../../../i18n';
import { IQuestionViewerProp } from '../GeneralQuestion/GeneralQuestionViewer';
import { black } from 'utils/style/colors';

interface IGridQuestionViewerProps extends IQuestionViewerProp {
  question: { data: IGridQuestionView; state: QuestionState };
}

const GridQuestionViewer: React.FC<IGridQuestionViewerProps> = ({
  tags,
  index,
  surveyId,
  question,
  displayDeleted,
  providerSurvey,
  readOnly,
  isOwnerOrSupport,
  ...otherProps
}) => {
  const {
    data: { parts, choiceList, mergeSumAndCount, unifyValueAndText },
  } = question;
  return (
    <QuestionViewer
      icon="grid"
      tags={tags}
      index={index}
      dispatch={appDispatch}
      surveyId={surveyId}
      question={question}
      displayDeleted={displayDeleted}
      providerSurvey={providerSurvey}
      readOnly={readOnly}
      child={(editing: boolean) =>
        !editing ? (
          <Fragment>
            <MultiChoiceViewer choices={parts} hasScore={false}>
              <p style={{ color: black }}>
                <Icon type="list" className="right" />
                <span>
                  {i18n.t('questionsMessage', { ns: 'survey' }) as string}
                </span>
              </p>
            </MultiChoiceViewer>
            <MultiChoiceViewer choices={choiceList} hasScore={true}>
              <p style={{ color: black }}>
                <Icon type="check-circle" className="right" />
                {i18n.t('gridChoicesMessage', { ns: 'survey' }) as string}
              </p>
            </MultiChoiceViewer>
            <GridFieldsViewer mergeSumAndCount={mergeSumAndCount} />
          </Fragment>
        ) : (
          <Fragment>
            <MultiChoiceEditor
              hasScore={false}
              messageName="parts"
              preventEdit={false}
            >
              <p style={{ color: black }}>
                <Icon type="list" className="right" />
                <span>
                  {i18n.t('questionsMessage', { ns: 'survey' }) as string}
                </span>
              </p>
            </MultiChoiceEditor>

            <MultiChoiceEditor
              hasScore={true}
              messageName="choiceList"
              preventEdit={unifyValueAndText}
            >
              <p style={{ color: black }}>
                <Icon type="check-circle" className="right" />
                {i18n.t('gridChoicesMessage', { ns: 'survey' }) as string}
              </p>
            </MultiChoiceEditor>
            <GridFieldsEditor isOwnerOrSupport={isOwnerOrSupport} />
          </Fragment>
        )
      }
      {...otherProps}
    />
  );
};

export default memo(
  GridQuestionViewer,
  (
    prevProps: IGridQuestionViewerProps,
    nextProps: IGridQuestionViewerProps
  ) => {
    return (
      prevProps.question === nextProps.question &&
      prevProps.index === nextProps.index &&
      prevProps.questionState === nextProps.questionState
    );
  }
);
